import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import {Location} from '@angular/common';

import {TerminaisNacionaisModel} from "./terminais-nacionais.model";
import {TerminaisNacionaisService} from './terminais-nacionais.service';
import {Funcoes} from "../funcoes";
import {Global} from "../global";


@Component({
  selector: 'app-terminais-form',
  templateUrl: './terminais-nacionais-form.component.html'
})
export class TerminaisNacionaisFormComponent implements OnInit {

  enviandoForm = false;
  form: FormGroup;
  title: string;
  terminal: TerminaisNacionaisModel = new TerminaisNacionaisModel();
  listEstados = [];
  pageIsUpd: boolean = false;
  pageIsAdd: boolean = false;

  constructor(
    formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private terminaisService: TerminaisNacionaisService,
    private _location: Location,
    public func: Funcoes,
    public global: Global
  ) {
    this.form = formBuilder.group({
      id_terminal: [],
      nome: ['', [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(85)
      ]],
      cidade: ['', [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(85)
      ]],
      estado: ['', [
        Validators.required
      ]],
    });

    this.listEstados = func.siglasEstados();
  }

  ngOnInit() {

    // verifica se é uma página de edição
    if(this.router.url.split(/\//).pop() == 'upd'){
      this.pageIsUpd = true;
    }

    // verifica se é uma página para adicionar
    if(this.router.url.split(/\//).pop() == 'add'){
      this.pageIsAdd = true;
    }

    let id = this.route.params.subscribe(params => {
      let id = params['id_terminal'];

      if(!this.pageIsUpd){
        this.title = this.func.traduzir('front.editarTerminal');
      }else{
        this.title = id ? this.func.traduzir('front.visualizarTerminal') : this.func.traduzir('front.cadastrarNovoTerminal');
      }

      if (!id) {
        return;
      }

      this.terminaisService.getById(id)
        .subscribe(
          json => {
            if(this.pageIsUpd) {
              this.title = this.title = this.func.traduzir('front.editarTerminal')+': '+json.Payload[0].nome;
            }else{
              this.title = this.func.traduzir('front.visualizarTerminal') + ': ' + json.Payload[0].nome;
            }
            this.terminal = json.Payload[0];

            if(this.global.debug == true){
              console.log(json.Payload[0]);
            }
          },
          error => {
            this.func.showErro(error.json());
          });
    });
  }

  voltar() {
    this._location.back();
  }

  save() {
    let result,
      values = this.terminal; // this.form.value;

    this.enviandoForm = true;

    if (values.id_terminal) {
      result = this.terminaisService.editar(values, values.id_terminal);
    } else {
      result = this.terminaisService.adicionar(values);
    }

    result.subscribe(data => this.router.navigate(['/painel', 'terminais-nacionais']),
      error => {
        let json = error.json();
        this.func.showErro(json);

        this.enviandoForm = false;

        for(let i in json.Message.ErrorInput){
          let erro = {};
          erro[i] = json.Message.ErrorInput[i];
          this.form.controls[i].setErrors(erro);
        }
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/terminais-nacionais/terminais-nacionais-form.component.ts